// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lZUeh","placeholdersHeader":"styles_placeholdersHeader__3aqzK","editorStyle":"styles_editorStyle__29pnv","placeholdersBox":"styles_placeholdersBox__1V1QL"};